import { Avatar, Box, Typography } from '@mui/material';
import { format } from 'date-fns';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { BaseUser, orderAtom } from '../state/state';
import { longDateFormat } from '../../common/state/state';
import PhotosUtils from '../../common/utils/photos.utils';

export default function OrderCreationInfo(): React.JSX.Element {
  const { t } = useTranslation(['order']);
  const order = useAtomValue(orderAtom);
  const orderCreator: BaseUser | null | undefined = order.is_auto_validated
    ? order.suggestor
    : order.user;

  const orderCreatorBlock = orderCreator ? (
    <>
      <Avatar size={24} src={PhotosUtils.getUserAvatarPicture(orderCreator)} variant="square" />
      <Typography variant="bodyMedium">
        {orderCreator.first_name}&nbsp;{orderCreator.last_name}
      </Typography>
    </>
  ) : (
    <Typography>-</Typography>
  );

  return (
    <Box sx={{ display: 'flex', gap: 3 }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, flexShrink: 0 }}>
        <Typography variant="bodySmall" color="secondary">
          {t('order:ordered_at')}
        </Typography>
        <Typography variant="bodyMedium" sx={{ lineHeight: '24px' }}>
          {format(order.created_at, longDateFormat)}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
        <Typography variant="bodySmall" color="secondary">
          {t('order:ordered_by')}
        </Typography>
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
          {orderCreatorBlock}
        </Box>
      </Box>
    </Box>
  );
}
